export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5025.e00c32c3.jpg";